/**********************************************************/
/*	@copyright	LAPINV.RU				                  */
/*	@support	https://lapinv.ru				          */
/**********************************************************/
import { slideToggle, slideDown, slideUp } from "../lib/collapse.js";
export const lightbox = GLightbox({
  touchNavigation: true,
  autoplayVideos: true,
});
export function initUtils() {
  // tabs
  const tabLinks = document.querySelectorAll("[data-tab-id]");
  if (tabLinks.length > 0) {
    const firstTabContainer = tabLinks[0]?.parentNode.nextElementSibling;
    if (!firstTabContainer || !firstTabContainer.querySelector("[data-tab]")) {
      console.warn(
        "Предупреждение: Табы ([data-tab]) не найдены на странице или они не в контейнере."
      );
      return;
    }

    let animating = false;

    // Если активного таба нет, делаем первый активным
    if (!firstTabContainer.querySelector("[data-tab].active")) {
      tabLinks[0].classList.add("active");
      const defaultTab = firstTabContainer.querySelector(
        `[data-tab="${tabLinks[0].dataset.tabId}"]`
      );
      defaultTab && defaultTab.classList.add("active");
    }

    tabLinks.forEach((link) => {
      link.addEventListener("click", () => {
        // Если идёт анимация или ссылка уже активна – выходим
        if (animating || link.classList.contains("active")) return;

        // Определяем родительский элемент и контейнер табов
        const parent = link.parentNode;
        const tabContainer = parent.nextElementSibling;
        // Определяем целевые табы по data-tab атрибуту
        const targetTabs = tabContainer.querySelectorAll(
          `[data-tab="${link.dataset.tabId}"]`
        );

        // Если табов с таким идентификатором нет, ничего не делаем
        if (!targetTabs.length) return;

        animating = true;

        // Обновляем активность ссылок в группе
        parent
          .querySelectorAll("[data-tab-id].active")
          .forEach((el) => el.classList.remove("active"));
        link.classList.add("active");

        // Активируем целевые табы
        targetTabs.forEach((tab) => {
          tab.style.display = "";
          tab.classList.remove("hide");
          tab.classList.add("active");
        });

        // Деактивируем остальные активные табы в контейнере
        tabContainer.querySelectorAll("[data-tab].active").forEach((tab) => {
          if (![...targetTabs].includes(tab)) {
            tab.classList.add("hide");
            setTimeout(() => tab.classList.remove("active", "hide"), 400);
          }
        });

        // Разблокируем переключение после завершения анимации
        setTimeout(() => (animating = false), 400);
      });
    });
  }

  // collapse
  const collapse = document.querySelectorAll("[data-collapse]");
  if (collapse.length > 0) {
    collapse.forEach((el) => {
      const parent = el.parentNode;
      const targetBlock = parent.querySelector("[data-collapse-block]");

      if (targetBlock) {
        if (parent.classList.contains("active")) {
          slideDown(targetBlock, 0);
        }

        el.addEventListener("click", () => {
          slideToggle(targetBlock).then((isVisible) => {
            parent.classList.toggle("active", isVisible);
          });
        });
      }
    });
  }

  // modal buttons source
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-modal-source]");
    if (!el) return;

    const source = el.dataset.modalSource;
    if (!source) return;

    const modal = document.querySelector(
      `[data-modal="${el.dataset.modalId}"]`
    );
    const form = modal?.querySelector("form");
    if (!form) return;

    let input = form.querySelector('input[name="source"]');

    input
      ? (input.value = source) // если уже есть — обновляем
      : (() => {
          const hidden = document.createElement("input");
          hidden.name = "source";
          hidden.dataset.vgformLabel = "Источник клика";
          hidden.dataset.vgformEmpty = "";
          hidden.value = source;
          hidden.classList.add("hidden");
          hidden.hidden = true;
          form.appendChild(hidden);
        })();
  });
}

export function getRem() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

// Функция для склонения слов
export function declOfNum(number, titles) {
  cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}

// Функция для перемещения элементов
export function moveElementsOnMobile() {
  if (window.innerWidth > 768) return;

  const processMove = (attribute, callback) => {
    document.querySelectorAll(`[${attribute}]`).forEach((element) => {
      let selector = element.getAttribute(attribute);
      selector = normalizeSelector(selector);

      const target = document.querySelector(selector);
      if (!target) return;

      // Получаем класс обертки
      const wrapperClass = element.getAttribute("data-move-wrapper");

      // Выполняем перемещение
      callback(element, target, wrapperClass);

      // Удаляем использованные атрибуты
      element.removeAttribute(attribute);
      element.removeAttribute("data-move-wrapper");
    });
  };

  // data-move-after
  processMove("data-move-after", (element, target, wrapperClass) => {
    moveElement(element, target, "after", wrapperClass);
  });

  // data-move-before
  processMove("data-move-before", (element, target, wrapperClass) => {
    moveElement(element, target, "before", wrapperClass);
  });

  // data-move-to и data-move-append
  processMove("data-move-to", (element, target, wrapperClass) => {
    moveElement(element, target, "append", wrapperClass);
  });

  processMove("data-move-append", (element, target, wrapperClass) => {
    moveElement(element, target, "append", wrapperClass);
  });

  // data-move-prepend
  processMove("data-move-prepend", (element, target, wrapperClass) => {
    moveElement(element, target, "prepend", wrapperClass);
  });
}

// Вспомогательная функция для перемещения с оберткой
function moveElement(element, target, position, wrapperClass) {
  let elementToMove = element;

  // Создаем обертку если нужно
  if (wrapperClass) {
    const wrapper = document.createElement("div");
    wrapper.className = wrapperClass;
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
    elementToMove = wrapper;
  }

  // Выполняем перемещение
  switch (position) {
    case "after":
      target.after(elementToMove);
      break;
    case "before":
      target.before(elementToMove);
      break;
    case "append":
      target.append(elementToMove);
      break;
    case "prepend":
      target.prepend(elementToMove);
      break;
  }
}

// Функция для нормализации селектора
function normalizeSelector(selector) {
  if (!selector) return null;
  let cleanSelector = selector.replace(/['"]/g, "").trim();
  if (cleanSelector.startsWith(".") || cleanSelector.startsWith("#")) {
    return cleanSelector;
  }
  return "." + cleanSelector;
}

export function setCookie(name, value, hours) {
  const date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

export function getCookie(name) {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split("=");
    if (cookieName === name) return cookieValue;
  }
  return null;
}
